import * as React from "react"
import { PopoverMutexContextProvider } from "@digits-shared/components/UI/Elements/PopUp/PopOverMutexContext"
import { DesktopChrome } from "src/frontend/components/OS/Chrome/Desktop/DesktopChrome"
import { TermsOfServiceCheck } from "src/frontend/components/OS/Shared/TermsOfService/TermsOfServiceCheck"
import { ViewTypeContextProvider } from "src/frontend/components/Shared/Contexts/ViewTypeContext"
import { ViewVersionContextProvider } from "src/frontend/components/Shared/Contexts/ViewVersionContextProvider"
import { BlockMobile } from "src/frontend/components/Shared/Responsive/BlockMobile"
import { Desktop } from "src/frontend/components/Shared/Responsive/Desktop"
import { Mobile } from "src/frontend/components/Shared/Responsive/Mobile"
import { useBlockMobile } from "src/frontend/components/Shared/Responsive/useBlockMobile"

const MobileChrome = React.lazy(
  () => import("src/frontend/components/OS/Chrome/Mobile/MobileChrome")
)

/*
  COMPONENTS
*/

export const OSChrome: React.FC = () => (
  <ViewTypeContextProvider>
    <ViewVersionContextProvider>
      <ResponsiveOSChrome />
    </ViewVersionContextProvider>
  </ViewTypeContextProvider>
)

const ResponsiveOSChrome: React.FC = () => {
  if (useBlockMobile()) return <BlockMobile />

  return (
    <>
      <TermsOfServiceCheck />
      <PopoverMutexContextProvider>
        <Desktop>
          <DesktopChrome />
        </Desktop>
        <Mobile>
          <MobileChrome />
        </Mobile>
      </PopoverMutexContextProvider>
    </>
  )
}
